module.exports = __webpack_public_path__ + "img/BoD_04_A_Prof_Chin_Jing_Jih.aaa09215.jpg";